import { stats } from "@/mocks/home";

export default function TrustBar() {
  return (
    <section className="w-full bg-primary-600">
      <div className="w-full px-4 md:px-8 py-10 md:py-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6 max-w-6xl mx-auto">
          {stats.map((stat) => (
            <div key={stat.label} className="flex items-center gap-4">
              <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-background-50/15 flex-shrink-0">
                <i className={`${stat.icon} text-2xl text-background-50`}></i>
              </span>
              <div className="flex flex-col">
                <span className="font-heading text-2xl md:text-3xl font-semibold text-background-50 leading-none">
                  {stat.value}
                </span>
                <span className="text-xs md:text-sm text-background-100/85 mt-1.5 leading-snug">
                  {stat.label}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}